import {
  Component,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
  OnInit,
  AfterViewInit,
  OnChanges,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { openConfirmationModal as openModal } from 'src/shared/utilities/modal-utilities';
import { FormEvents } from 'src/shared/constants';
import { SelectListOption, yesNoOptions } from 'src/shared/models/SelectListOptions';
import {
  AddOrUpdatePersonsPhoneCommand,
  DeletePersonsPhoneCommand,
  ProfileClient,
  PersonPhoneDto,
  PhoneCodeDto,
} from 'src/shared/services/api.service';
import { catchValidationErrors } from 'src/shared/validation/validator-utilities';

@Component({
  standalone: false,
  selector: 'edportal-educator-contact-phone-form',
  templateUrl: './educator-contact-phone-form.component.html',
  styleUrls: ['./educator-contact-phone-form.component.scss'],
})
export class EducatorContactPhoneFormComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() phoneNumber!: PersonPhoneDto | undefined;
  @Input() phoneOptions!: PhoneCodeDto[];
  @Output() phoneChanged = new EventEmitter<FormEvents>();

  @ViewChild('addOrUpdatePhoneForm') form!: NgForm;
  errorEmitter = new EventEmitter<any>();

  yesNoOptions: SelectListOption<boolean>[] = yesNoOptions;
  addOrUpdatePersonsPhoneCommand!: AddOrUpdatePersonsPhoneCommand;
  filteredPhoneOptions!: PhoneCodeDto[];

  constructor(
    private readonly profileClient: ProfileClient,
    private readonly modalService: NgbModal,
    private readonly renderer: Renderer2,
  ) {}

  ngOnInit() {
    this.assignCommandFromPhoneNumber();
    this.filterPhoneOptions();
  }

  ngAfterViewInit() {
    this.renderer.selectRootElement('#number').focus();
  }

  assignCommandFromPhoneNumber() {
    this.addOrUpdatePersonsPhoneCommand = {
      personPhoneNumberId: this.phoneNumber?.personPhoneNumberId,
      phoneCodeId: this.phoneNumber?.phoneCodeId ?? undefined,
      number: this.phoneNumber?.phoneNumber ?? undefined,
      isMobile: this.phoneNumber?.isMobile ?? undefined,
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.phoneNumber) {
      this.assignCommandFromPhoneNumber();
      this.filterPhoneOptions();
    }
  }

  cancelAddPhone() {
    this.phoneChanged.emit(FormEvents.Cancelled);
  }

  onSubmitPhone() {
    const isAdd = !this.addOrUpdatePersonsPhoneCommand?.personPhoneNumberId;

    const observable = isAdd
      ? this.profileClient.addPersonsPhone(this.addOrUpdatePersonsPhoneCommand)
      : this.profileClient.updatePersonsPhone(this.addOrUpdatePersonsPhoneCommand);

    observable.pipe(catchValidationErrors(this.form, this.errorEmitter)).subscribe({
      next: () => {
        this.phoneChanged.emit(FormEvents.Successful);
      },
      error: () => {
        this.phoneChanged.emit(FormEvents.Error);
      },
    });
  }

  openConfirmationModal() {
    openModal(
      this.modalService,
      'Delete Phone Number',
      'Are you sure you want to delete this phone number? Operation can not be undone.',
      () => this.deleteExistingPhone(),
      { size: 'sm' },
    );
  }

  deleteExistingPhone() {
    const deletePersonsPhoneCommand: DeletePersonsPhoneCommand = {
      personPhoneNumberId: this.phoneNumber!.personPhoneNumberId,
    };

    this.profileClient.deletePersonsPhone(deletePersonsPhoneCommand).subscribe({
      next: () => {
        this.phoneChanged.emit(FormEvents.Successful);
      },
      error: () => {
        this.phoneChanged.emit(FormEvents.Error);
      },
    });
  }

  filterPhoneOptions() {
    if (typeof this.phoneNumber?.personPhoneNumberId === 'undefined') {
      this.filteredPhoneOptions = this.phoneOptions.filter((x) => x.description.toLowerCase() !== 'unknown');
    } else {
      this.filteredPhoneOptions = this.phoneOptions;
    }
  }

  removeUnknown() {
    this.phoneOptions = this.phoneOptions.filter((x) => x.description.toLowerCase() !== 'unknown');
  }
}
